/* eslint-disable no-param-reassign */
import { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'
import PropTypes from 'prop-types'
import { ReactComponent as InfoTwoTone } from 'core/assets/images/icn-info-two-tone.svg'
import i18n from 'core/common/i18n'
import { checkIfImageHasBadResolution } from 'core/common/utils/imageResolution'
import { Tooltip } from 'core/components/Core'
import { actionsUpload, useUpload } from 'core/containers/ProductUpload/context'
import RemoveFileDialog from './components/RemoveFileDialog'
import RemoveFileNotPossibleDialog from './components/RemoveFileNotPossibleDialog'
import ZoomFileDialog from './components/ZoomFileDialog'
import {
  ActionBox,
  Actions,
  StyledDeleteOutlineIcon,
  StyledStarBorderIcon,
  StyledStarIcon,
  StyledZoomInIcon,
  LeftActions,
} from './style'

function FileActions({ file, hasError, hasWarning, checkDependencies }) {
  const formikContext = useFormikContext()
  const [stateUpload, dispatchUpload] = useUpload()
  const [zoomDialog, setZoomDialog] = useState(false)
  const [removeDialog, setRemoveDialog] = useState(false)
  const [imageResolution, setImageResolution] = useState(false)
  const [removeNotPossibleDialog, setRemoveNotPossibleDialog] = useState(false)
  useEffect(() => {
    const run = async () => {
      const hasImageBadResolution = await checkIfImageHasBadResolution(file?.url)
      setImageResolution(hasImageBadResolution)
    }

    run()
  }, [file])

  const onSetCover = () => {
    dispatchUpload({ type: actionsUpload.SET_COVER, state: file })
  }

  const onRemoveFile = () => {
    if (!checkDependencies) {
      return setRemoveDialog(true)
    }

    const fileIsSelectedInVariations = variations => {
      if (!variations.length) return false
      const files = variations.map(item => item.images).flat()
      const existFile = files.find(item => item.id_ref === file.id_ref)
      return existFile
    }

    const isNotPossibleRemove = fileIsSelectedInVariations(formikContext.values.variations)

    if (isNotPossibleRemove) {
      setRemoveNotPossibleDialog(true)
    } else {
      setRemoveDialog(true)
    }
  }

  const onConfirmRemoveFile = () => {
    setRemoveDialog(false)
    dispatchUpload({ type: actionsUpload.REMOVE_FILE, state: file })
  }

  const IS_UPLOADING = stateUpload.UPLOAD_STATUS === 'IN_PROGRESS'

  return (
    <>
      {!IS_UPLOADING && (
        <>
          {!hasError && hasWarning && imageResolution && (
            <LeftActions>
              <InfoTwoTone />
            </LeftActions>
          )}

          <Actions>
            {!hasError && (
              <Tooltip title={i18n.t('product.productUpload.imageDefault')}>
                <ActionBox onClick={() => onSetCover(file)}>
                  {file.cover ? <StyledStarIcon /> : <StyledStarBorderIcon />}
                </ActionBox>
              </Tooltip>
            )}

            {!hasError && (
              <Tooltip title={i18n.t('product.productUpload.zoom')}>
                <ActionBox onClick={() => setZoomDialog(file)}>
                  <StyledZoomInIcon />
                </ActionBox>
              </Tooltip>
            )}

            <Tooltip title={i18n.t('product.productUpload.deleteImage')}>
              <ActionBox onClick={() => onRemoveFile(file)}>
                <StyledDeleteOutlineIcon />
              </ActionBox>
            </Tooltip>
          </Actions>
        </>
      )}

      <ZoomFileDialog zoomDialog={zoomDialog} onClose={setZoomDialog} />
      <RemoveFileDialog
        open={removeDialog}
        onClose={setRemoveDialog}
        onConfirm={onConfirmRemoveFile}
      />
      <RemoveFileNotPossibleDialog
        open={removeNotPossibleDialog}
        onClose={setRemoveNotPossibleDialog}
      />
    </>
  )
}

FileActions.defaultProps = {
  checkDependencies: false,
}

FileActions.propTypes = {
  file: PropTypes.object.isRequired,
  hasError: PropTypes.bool.isRequired,
  checkDependencies: PropTypes.bool,
}

export default FileActions
